document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.wp-block-navigation__responsive-container-open');
    const navContainer = document.querySelector('.wp-block-navigation__responsive-container');
    
    if (menuToggle && navContainer) {
        menuToggle.addEventListener('click', function() {
            navContainer.classList.toggle('is-open');
        });
    }
});